import script from "./TressFilter.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressFilter.vue?vue&type=script&lang=ts&setup=true"

import "./TressFilter.vue?vue&type=style&index=0&id=d5ae8d6a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5ae8d6a"]])

export default __exports__